import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import living from "../Assets/about/amyra-street-banner.webp";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import map from "../Assets/maps/amayra-tullium-street-map.webp";
import locationMap from "../Assets/maps/location-4.webp";
import {
  FaUniversity,
  FaHospital,
  FaBus,
  FaPlane,
  FaShoppingBag,
  FaTrain,
  FaChevronLeft,
  FaChevronRight,
  FaStore,
  FaBeer,
  FaBuilding,
  FaDumbbell,
  FaShoppingCart,
  FaGamepad,
} from "react-icons/fa";
import gallery1 from "../Assets/street/street-1.webp";
import gallery2 from "../Assets/street/street-2.webp";
import gallery3 from "../Assets/maps/img-3.webp";
import gallery4 from "../Assets/maps/img-4.webp";
import gallery5 from "../Assets/maps/img-5.webp";
import gallery6 from "../Assets/maps/img-6.webp";
import gallery9 from "../Assets/street/street-3.webp";
import backgroundAm3 from "../Assets/Media/Amayra-text-bg.jpg";
import club from "../Assets/street/mall-city.webp";
import clunhouse1 from "../Assets/street/banquet.webp";
import clunhouse2 from "../Assets/street/gamesroom.webp";
import clunhouse3 from "../Assets/street/gym.webp";
import clunhouse4 from "../Assets/street/resturants-img.webp";
import clunhouse5 from "../Assets/street/retail-outlets.webp";
import clunhouse6 from "../Assets/street/spa.webp";
import { MdOutlineFileDownload, MdStoreMallDirectory } from "react-icons/md";
import { IoRestaurant } from "react-icons/io5";

gsap.registerPlugin(ScrollTrigger);

const highlightsLeft = [
  { logo: <FaStore size={28} />, label: "Retail Stores" },
  { logo: <MdStoreMallDirectory size={28} />, label: "Showrooms" },
  { logo: <FaBeer size={28} />, label: "Microbrewery" },
];

const highlightsCenter = [
  { logo: <FaBuilding size={28} />, label: "Office Space" },
  { logo: <FaDumbbell size={28} />, label: "Gymnasium" },
  { logo: <FaGamepad size={28} />, label: "Gaming Zone" },
];

const highlightsRight = [
  { logo: <MdStoreMallDirectory size={28} />, label: "Shops" },
  { logo: <FaShoppingCart size={28} />, label: "Hypermarket" },
  { logo: <IoRestaurant size={28} />, label: "Fine Dine Restaurants" },
];
const amenities = [
  {
    title: "BANQUET",
    img: clunhouse1, // replace with your image
  },
  {
    title: "GAMEROOM",
    img: clunhouse2,
  },
  {
    title: "GYM",
    img: clunhouse3,
  },
  {
    title: "RESTAURANT",
    img: clunhouse4,
  },
  {
    title: "RETAIL OUTLET",
    img: clunhouse5,
  },
  {
    title: "SPA",
    img: clunhouse6,
  },
];
const amenitiesList = [
  { number: "01", label: "Commercial Entry" },
  { number: "02", label: "Commercial Exit" },
  { number: "03", label: "Housing Entry/Exit" },
  { number: "04", label: "Waterbody" },
  { number: "05", label: "4-Wheeler Parking" },
  { number: "06", label: "Ramp to Basement" },
  { number: "07", label: "Seats" },
  { number: "08", label: "Lawn" },
  { number: "09", label: "Kid's Play Area" },
  { number: "10", label: "Club" },
  { number: "11", label: "Skating Rink" },
  { number: "12", label: "Outdoor Fitness" },
  { number: "13", label: "Cricket Pitch" },
  { number: "14", label: "Yoga Lawn" },
  { number: "15", label: "Reflexogy Park" },
  { number: "16", label: "Fire Pit" },
  { number: "17", label: "Badminton Court" },
  { number: "18", label: "Guard's Room" },
  { number: "19", label: "Stairs" },
  { number: "20", label: "Parking Cum Plaza" },
  { number: "21", label: "Entry to Plaza" },
  { number: "22", label: "Corridor" },
  { number: "23", label: "Basketball Court" },
];
const locations = [
  {
    title: "Rayat Bahara University ",
    time: "- 8 Mins",
    icon: <FaUniversity className="text-black-800 text-[33px]" />,
  },
  {
    title: "Hospital",
    time: " - 7 Mins",
    icon: <FaHospital className="text-black-800 text-[33px]" />,
  },
  {
    title: "Kharar Bus Stand",
    time: " - 3 Mins",
    icon: <FaBus className="text-black-800 text-[33px]" />,
  },
  {
    title: "International Airport",
    time: " - 25 Mins",
    icon: <FaPlane className="text-black-800 text-[33px]" />,
  },
  {
    title: "VR Punjab Mall",
    time: "  - 10 Mins",
    icon: <FaShoppingBag className="text-black-800 text-[33px]" />,
  },
  {
    title: "Mohali Railway Station",
    time: " - 20 Mins",
    icon: <FaTrain className="text-black-800 text-[33px]" />,
  },
];

const HexagonItem = ({ logo, label }) => (
  <div className="flex items-center gap-1 flex-1">
    <div className="pr-1 text-[#fff] text-[18px] flex items-center justify-center relative">
      {logo}
    </div>
    <p className="flex lg:text-[18px] text-[16px] text-left text-white font-medium wrap-break-word">
      {label}
    </p>
  </div>
);

// Custom Arrow Components
const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute -top-8 right-12 bg-gray-800 hover:bg-gray-700 text-white p-2 rounded-full z-10"
  >
    <FaChevronLeft />
  </button>
);

const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute -top-8 right-2 bg-gray-800 hover:bg-gray-700 text-white p-2 rounded-full z-10"
  >
    <FaChevronRight />
  </button>
);

const TrilliumStreet = () => {
  const heroRef = useRef(null);
  const mapSectionTitleRef = useRef(null);
  const mapSectionTextRef = useRef(null);
  const sitePlanImageRef = useRef(null);
  const amenitiesTitleRef = useRef(null);
  const amenitiesListRef = useRef([]);
  const locationCardsRef = useRef([]);
  const sitePlanTitleRef = useRef(null);
  const galleryRef = useRef(null);

  const addToLocationCardsRef = (el) => {
    if (el && !locationCardsRef.current.includes(el)) {
      locationCardsRef.current.push(el);
    }
  };
  useEffect(() => {
    // Hero section animation
    gsap.from(heroRef.current, {
      opacity: 0,
      y: 100,
      duration: 1,
      scrollTrigger: {
        trigger: heroRef.current,
        start: "top bottom",
        toggleActions: "play none none none",
      },
    });
    // Clean up
    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  const addToAmenitiesListRef = (el) => {
    if (el && !amenitiesListRef.current.includes(el)) {
      amenitiesListRef.current.push(el);
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="min-h-screen">
      {/* Hero Banner */}
      <section
        ref={heroRef}
        className="mt-[-107px] relative h-[100vh] flex items-end justify-start"
        style={{
          backgroundImage: `url(${living})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          overflow: "hidden",
        }}
      >
        <div className="w-full z-10 md:px-4 px-2 pb-[40px] flex justify-between items-end">
          <div className="floating-element mx-auto bg-opacity-20  w-full flex md:flex-row flex-col items-center justify-between">
            {/* Heading */}
            <h1
              className="md:text-7xl text-5xl font-bold text-white mb-8"
              style={{ textShadow: "2px 2px 4px rgba(0,0,0,0.8)" }}
            >
              Amayra Trillium Street
            </h1>
            {/* Image above heading */}

            <div>
              <a
                href="/"
                className="bg-white text-[14px] text-[#521a27]-700 font-semibold px-3 py-2 shadow-lg hover:bg-gray-200 transition mb-4 flex items-center justify-center gap-1"
              >
                <b> PBRERA-SAS80-PC0306 </b>
              </a>

              <a
                href="/COMMERCIAL_FINAL.pdf"
                className="bg-white text-[22px] text-black-700 font-semibold px-6 py-2 shadow-lg hover:bg-gray-200 transition mb-4 flex items-center gap-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Brochure <MdOutlineFileDownload className="text-2xl" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* map section */}
      <div className="bg-white lg:p-[40px] p-[20px] gap-4">
        <div className="flex flex-col gap-4">
          {/* Left - Location Cards */}
          <div className="w-full flex flex-col gap-1 items-top">
            <div className="lg:flex lg:flex-row flex-col gap-2 justify-between items-center">
              <h2
                ref={mapSectionTitleRef}
                className="h2 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px]  font-bold mb-[10px] leading-[120%]"
              >
                Strategic Location
                <br className="hidden lg:block" /> Meets Business Growth
              </h2>
              <p
                ref={mapSectionTextRef}
                className="max-w-xl w-full pb-[20px] font-normal text-[16px]"
              >
                Townbell Group commitment to quality & trust, its customer
                sensitivity, and its stance of delivering on promise with
                agility and value, ensure smarter and efficient offerings at all
                times. The Group's collective expertise in the commercial sector
                - and sustained efforts in enhancing it further - assures
                clients of superior service and value at all times. Amayra
                Trillium Street is all about going beyond space delivery and
                management. It is about building value for the client's
                business.
              </p>
            </div>
            <div className="w-[100%] text-center h-[0.5px] bg-[#ccc] mx-auto mb-2"></div>
          </div>

          {/* Right - Map Image */}
          <div className="w-full grid lg:grid-cols-1 gap-2 justify-center text-center items-top">
            <h2 className="h2 capitalize 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px] text-center font-semibold leading-snug mb-[20px] mx-auto">
              Site Layout Plan
            </h2>
            <img
              ref={sitePlanImageRef}
              src={map}
              alt="Location Map"
              className="mx-auto"
              loading="lazy"
              decoding="async"
            />
            <div>
              <h5
                ref={amenitiesTitleRef}
                className="capitalize text-left md:text-[45px] text-[30px] mb-2 font-bold"
              >
                Amenities Map Key
              </h5>
              <div className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 mx-auto">
                {amenitiesList.map((item, idx) => (
                  <div
                    key={idx}
                    ref={addToAmenitiesListRef}
                    className="group relative pl-0 py-[10px] overflow-hidden rounded-[20px] cursor-pointer"
                  >
                    {/* Water drop overlay */}
                    <div className="absolute inset-0 bg-[#521a27] scale-0 group-hover:scale-100 transition-transform duration-500 ease-out rounded-[20px] origin-center z-0"></div>
                    <div className="relative z-10 flex items-center justify-start gap-1 mb-0 lg:leading-[40px] leading-[120%] px-4">
                      <p className="capitalize text-black-500 md:text-[18px] text-[14px] font-semibold flex flex-1 items-center  lg:text-center text-start transition-colors duration-300 group-hover:text-white my-1 ">
                        <b className="text-black-700 lg:text-[45px] text-[25px] pr-[10px] group-hover:text-white">
                          <i>{item.number}</i>
                        </b>{" "}
                        {item.label}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* plans section */}
      <div className="bg-black relative text-white z-999">
        <div className="w-full flex flex-col lg:flex-row justify-center">
          {/* Left Image */}
          <div className="w-full lg:basis-[55%]">
            <img
              src={club}
              alt="Project Club View"
              className="w-full"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Right Content */}
          <div
            className="w-full lg:basis-[45%] md:p-8 p-5 flex flex-col justify-center"
            style={{
              backgroundImage: `url('${backgroundAm3}')`,
              backgroundPosition: "left center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <h2 className="capitalize text-left text-3xl font-bold border-b border-[#cccccc42] pb-5">
              A Perfect Match for Your Business
            </h2>
            <p className="text-[16px] my-5 text-white-700">
              Find the ideal space that aligns perfectly with your vision.
              Designed to enhance productivity and inspire growth. Prime
              locations that connect you to customers and opportunities.
              Flexible layouts to suit businesses of all sizes. Built with
              quality, style, and your success in mind.
            </p>
            <div className="w-full lg:flex flex-row lg:justify-between justify-center pt-4 gap-10">
              {/* Left Column */}
              <div className="flex flex-col flex-1 md:gap-6 gap-2">
                {highlightsLeft.map((item, idx) => (
                  <HexagonItem key={idx} {...item} />
                ))}
              </div>

              {/* Center Column */}
              <div className="flex flex-col flex-1 md:gap-6 gap-2 lg:mt-0 mt-3">
                {highlightsCenter.map((item, idx) => (
                  <HexagonItem key={idx} {...item} />
                ))}
              </div>

              {/* Right Column */}
              <div className="flex flex-col  flex-1 md:gap-6 gap-2 lg:mt-0 mt-3">
                {highlightsRight.map((item, idx) => (
                  <HexagonItem key={idx} {...item} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* slider section */}
      <section className="w-full md:py-10 py-5 bg-white relative">
        <div className="w-full md:px-6 px-4 lg:flex-row flex mb-7 justify-between items-center flex-col">
          <div className="flex">
            <h2 className="h2 capitalize 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px] font-bold text-black mb-4 leading-[110%]">
              Premium Business
              <br className="hidden lg:block" /> Destination For Growth
            </h2>
          </div>
          <span className="lg:w-1/2 w-full text-gray font-normal text-[16px]">
            The future of retail is here. Amayra Trillium Street will be a
            landmark destination for numerous Restaurants, Retail Outlets,
            Salons, Spas, Gyms, and Wellness Centres catering to the needs of
            the ever-growing community nearby.
          </span>
        </div>
        <div className="w-[100%] text-center h-[0.5px] bg-[#ccc] mx-auto mb-2"></div>

        <div className="container mx-auto px-4">
          {/* Heading */}
          <div className="flex justify-between items-center mb-6 relative">
            <div className="h-1 w-12 bg-black-700 mt-2"></div>
          </div>

          {/* Slider */}
          <Slider {...settings}>
            {amenities.map((item, index) => (
              <div key={index} className="w-full px-2 mt-3">
                <div className="relative group overflow-hidden shadow-lg">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-[300px] object-cover transform group-hover:scale-105 transition duration-500"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="w-full bg-opacity-50 text-black py-2 text-center text-lg font-bold">
                    {item.title}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* Last Section - Image Slider */}
      <section className="bg-[#1f1e1c] lg:py-12 py-0 lg:px-4 px-2 relative z-999">
        <div
          ref={galleryRef}
          className="w-full mx-auto flex flex-cols flex-wrap p-4 gap-4 lg:justify-center justify-normal"
        >
          <div className="w-full lg:px-6 px-0 lg:flex-row flex mb-7 justify-between items-center flex-col">
            <div className="flex">
              <h2 className="capitalize 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px] font-bold text-white mb-4 leading-[120%]">
                A Luxurious Location
                <br className="hidden lg:block" /> A Stunning Facade
              </h2>
            </div>
            <span className="lg:w-1/2 w-full text-white text-[16px]">
              Our well-integrated commercial Hub will have a distinct take on
              corporate lifestyle & serves as a one-stop destination for the
              established & emerging entrepreneurs & start-ups. Our basic idea
              is not only to provide a rare mix of excellent location, amenities
              & accessibility but also best suitability for creative & emotional
              well-being of the employee.
            </span>
          </div>
          <div className="2xl:w-[100%] w-[90%] text-center h-[0.5px] bg-[#ffffff75] mx-auto mb-2"></div>
          <div className="flex flex-col lg:gap-4 gap-2  lg:max-w-[30%] max-w-[100%] md:mt-[50px] mt-5">
            <div className="relative w-full">
              <img
                src={gallery1}
                alt="Gym"
                className="w-full h-auto object-cover shadow-xl"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="relative w-full">
              <img
                src={gallery4}
                alt="Building"
                className="w-full h-auto object-cover shadow-xl"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          <div className="flex flex-col lg:gap-4 gap-2 lg:max-w-[30%] max-w-[100%] ">
            <div className="relative w-full">
              {" "}
              {/* Adjust the margin-top to move the middle image up */}
              <img
                src={gallery2}
                alt="Building"
                className="w-full h-auto object-cover shadow-xl"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="relative w-full">
              {" "}
              {/* Adjust the margin-top to move the middle image up */}
              <img
                src={gallery5}
                alt="Pool with float"
                className="w-full h-auto object-cover shadow-xl"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          <div className="flex flex-col lg:gap-4 gap-2 lg:max-w-[30%] max-w-[100%] md:mt-[50px] mt-1">
            <div className="relative w-full">
              <img
                src={gallery3}
                alt="Pool"
                className="w-full h-auto object-cover shadow-xl"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="relative w-full">
              <img
                src={gallery6}
                alt="Family"
                className="w-full h-auto object-cover shadow-xl"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="relative w-full">
              <img
                src={gallery9}
                alt="Family"
                className="w-full h-auto object-cover shadow-xl"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </section>

      {/* siteplan proof */}
      <div>
        <div className="w-full grid lg:grid-cols-2  items-center m-0">
          {/* Left -Map Image*/}
          <div className="flex justify-center items-center h-full p-0 m-0">
            <img
              src={locationMap}
              alt="Location Map"
              className="w-max-5xl m-0 h-full"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Right -  Location Cards  */}
          <div className="grid grid-cols-1 sm:grid-cols-1 md:p-12 p-5 md:gap-2 gap-1 bg-[#612831] h-full">
            <div
              ref={sitePlanTitleRef}
              className="w-full flex flex-col m-0 md:pb-5 md-px-4 p-0"
            >
              <h2 className="2xl:text-[40px] xl:text-[36px] lg:text-[33px] md:text-[30px] text-[25px] text-white font-bold leading-snug md:mb-5 mb-2 capitalize">
                A New Marvel In The Vicinity Of Greater Mohali
              </h2>
            </div>
            {locations.map((item, idx) => (
              <div
                key={idx}
                ref={addToLocationCardsRef}
                className="group relative flex flex-col items-start p-0 text-white transition-shadow duration-300"
              >
                {/* Content container */}
                <div className="flex w-full relative z-10 items-center gap-4 border border-[#612831] hover:border-[#ccc] hover:rounded-2xl p-4 cursor-pointer">
                  <div className="w-10 h-10 flex items-center justify-center text-black-600 duration-300">
                    {item.icon}
                  </div>
                  <div className="flex-1">
                    <h4 className="text-white-900 text-xl font-semibold transition-colors duration-300">
                      {item.title} {item.time}
                    </h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrilliumStreet;
